import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap"
import * as styles from "./HeroBanner.module.css";

const HeroBanner = ({ data, isSingle = false }) => {
  if (!data) {
    return null; // Ensure the component doesn't render if no data is passed.
  }

  const {
    title,
    date,
    featuredImage,
    author,
    dailycategories,
    categories,
  } = data;
  const terms = categories?.nodes?.length > 0 ? categories.nodes : dailycategories?.nodes || [];
  console.log(featuredImage)
  return (
    <section className="slider-section digitl-article-banner digi-article-hero-new">
      <div
        className={`${styles.background} ar-slide-item item`}
        style={{
          background: `url('${featuredImage?.node?.localFile?.publicURL}')`,
          backgroundSize: "cover",
        }}
      >
        <Container className="digi-bnr-cont-fluid">
          <Row>
            <Col md={9}>
              <h1
                className={`${styles.title} text-size-44`}
                style={{
                  color: "#fff",
                  marginBottom: "1.041vw",
                }}
                itemProp="headline"
              >
                {title || "Default Title"}
              </h1>
              <ul className={` ${isSingle ? 'text-white font-bold flex-column align-items-start' : 'article-profile-list'} mb-0`}>
                {!isSingle && (
                  <li>
                    <GatsbyImage
                      image={getImage(
                        author?.node?.aCFuser?.uUserPhoto?.node?.localFile
                      )}
                      alt={author?.node?.name || "Author"}
                    />
                  </li>
                )}
                {!isSingle && <li>By {author?.node?.name} </li>}
                {isSingle && <li>{date}</li>}
                <li>
                  {isSingle ? 'Categories: ' : 'in '}
                  {terms.length > 0
                    ? terms.map((cat, index) => (
                        <span key={cat.slug}>
                          {index > 0 && ", "}
                          <Link to={cat.uri} className='text-decoration-none text-white'>{cat.name}</Link>
                        </span>
                      ))
                    : "Uncategorized"}
                </li>

                {!isSingle && <li>on {date || "Unknown Date"}</li>}
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
};

export default HeroBanner;
